module.exports = __webpack_public_path__ + "img/logo-full_lugano.56f702d4.png";